import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';
import euiFormClasses from 'v-components/classes/euiFormClasses';
import euiFormTextruta from 'v-components/euiFormTextruta.vue';
import euiFormKryssruta from 'v-components/euiFormKryssruta.vue';
import euiFormRadiogrupp from 'v-components/euiFormRadiogrupp.vue';
import euiFormSelect from 'v-components/euiFormSelect.vue';

import objectToFormData from 'object-to-formdata';

import { AnvandareFormModel } from 'classes/AnvandareFormModelClasses';


window.ssoAnvandare = window.ssoAnvandare || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiMermeny,
		euiDialog,
		euiFormTextruta,
		euiFormKryssruta,
		euiFormRadiogrupp,
		euiFormSelect,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		// Obs! Måste stämma med form model som används i controllern:
		inbjudanFormModelDefault: window.ssoAnvandare.inbjudanFormModelDefault,

		inbjudanFormModel: undefined,	// Den användaren kan editera och skicka. Sätts i js-kod.

		// I dessa sparas behörigheter/begränsning separat för licens- resp företagsanvändare. In-/utswappning sker i js då åtkomsttypen ändras:
		inbjudanFormModelBehorigheterLicens: undefined,
		inbjudanFormModelBehorigheterForetag: undefined,

		anvandareFormModel: undefined,	// Den användaren kan editera och skicka. Sätts i js-kod.
		anvandareFormForetagNamn: undefined, 	// Företagets namn (vid företagsanvändare) ska presenteras i formuläret, men ligger i övrigt utanför FormModel ovan. Hanteras därför utanför/separat. Sätts i js-kod.

		inbjudanDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			new euiDialogClasses.knappEvent('Skicka inbjudan', 'skickaInbjudan', { validateBeforeEmit: true }),
		]),

		anvandareDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			new euiDialogClasses.knappEvent('Spara', 'sparaAnvandare', { validateBeforeEmit: true }),
		]),

		hovrarFotnot1: false,	// Initialt så.
	},

	computed:
	{
		// Används endast då dialogrutan Bjud in... är öppen:

		valdAnvandartypArLicens() {
			return (!!this.inbjudanFormModel && this.inbjudanFormModel.Anvandartyp === this.$_anvandartypLicens);
		},
		valdAnvandartypArForetag() {
			return (!!this.inbjudanFormModel && this.inbjudanFormModel.Anvandartyp === this.$_anvandartypForetag);
		},
	},

	watch: {
		valdAnvandartypArLicens(nyttVarde, tidigareVarde) {
			if (nyttVarde === true)
			{
				if (!this.inbjudanFormModelBehorigheterLicens)
				{
					// Om undansparade behörigheter för licensanvändare saknas:
					// Sätt till defaultvärden för licensanvändare:
					this.inbjudanFormModelBehorigheterLicens = {
						PowerUser: true,
						Administrator: false,
						LockedDown: false,
					};
				}

				if (this.inbjudanFormModelBehorigheterForetag)
				{
					// Om företagsanvändare tidigare varit valt:
					// Spara undan aktuella värden för företagsanvändare:
					this.inbjudanFormModelBehorigheterForetag = {
						PowerUser: this.inbjudanFormModel.PowerUser,
						Administrator: this.inbjudanFormModel.Administrator,
						LockedDown: this.inbjudanFormModel.LockedDown,
					};
				}

				// Återställ undansparade behörigheter för licensanvändare:
				this.inbjudanFormModel = Object.assign(this.inbjudanFormModel, this.inbjudanFormModelBehorigheterLicens);
			}
		},

		valdAnvandartypArForetag(nyttVarde, tidigareVarde) {
			if (nyttVarde === true)
			{
				if (!this.inbjudanFormModelBehorigheterForetag)
				{
					// Om undansparade behörigheter för företagsanvändare saknas:
					// Sätt till defaultvärden för företagsanvändare:
					this.inbjudanFormModelBehorigheterForetag = {
						PowerUser: false,
						Administrator: false,
						LockedDown: false,
					};
				}

				if (this.inbjudanFormModelBehorigheterLicens)
				{
					// Om licensanvändare tidigare varit valt:
					// Spara undan aktuella värden för licensanvändare:
					this.inbjudanFormModelBehorigheterLicens = {
						PowerUser: this.inbjudanFormModel.PowerUser,
						Administrator: this.inbjudanFormModel.Administrator,
						LockedDown: this.inbjudanFormModel.LockedDown,
					};
				}

				// Återställ undansparade behörigheter för företagsanvändare:
				this.inbjudanFormModel = Object.assign(this.inbjudanFormModel, this.inbjudanFormModelBehorigheterForetag);
			}
		},
	},

	methods: {

		// Denna genererar mermenyn för en (1) enskild bestämd användare:
		menyConfigForEnAnvandare(anv, anvandartyp, farTasBortMapSistaBekraftadeAdministratoren, licensForetagPersonForandringsskydd)
		{
			const mc = new euiPopUpMenyClasses.menyConfig([
					new euiPopUpMenyClasses.delEvent('Ändra', 'andraAnvandare', {
						ikon: 'andra',
						eventData: { anv, anvandartyp, licensForetagPersonForandringsskydd },
					}),
				]);

			if (!anv.Confirmed)
			{
				mc.menydelar.push(
					new euiPopUpMenyClasses.delEvent('Skicka inbjudan på nytt', 'skickaInbjudanPaNytt', {
						ikon: 'mejl',
						eventData: {
								anvandartyp,
								licenseId: anv.LicenseId,
								atkomstTillforetagId: anv.CompanyId,
								atkomstTillforetagNamn: anv.CompanyName,
								inbjudenPersonId: anv.PersonId,
								inbjudenPersonEpost: anv.Email,
								inbjudenPersonNamn: anv.Name,
								forandringsskydd: licensForetagPersonForandringsskydd,		// LicenseForetagPerson...
							},
					})
				);
			}

			//// Todo: Fler saker ska väl begränsas efter roller! Nä, hela sidan kan bara kommas åt av Adm!
			////if (this.isAdministrator)
			////{
			//	mc.menydelar.push(
			//		new euiPopUpMenyClasses.delEvent('Återställ användarens lösen', 'aterstallLosen', {
			//			ikon: 'aterstallLosen',
			//			cssModifierClass: '-fara'
			//		})
			//	);
			////}

			mc.menydelar.push(
				new euiPopUpMenyClasses.delEvent('Ta bort åtkomsten', 'taBortAtkomst', {
					ikon: 'taBort',
					cssModifierClass: '-fara',
					disabled: !farTasBortMapSistaBekraftadeAdministratoren || anv.PersonId === this.currentUser,
					tooltip:
						(!farTasBortMapSistaBekraftadeAdministratoren ? 'Den här åtkomsten kan inte tas bort eftersom detta är<br>den enda administratören.' : undefined)
						|| (anv.PersonId === this.currentUser ? 'Du kan inte ta bort din egen åtkomst. Det måste<br>någon annan administratör göra.' : undefined),
					eventData: {
							personName: anv.Name,
							personEmail: anv.Email,
							foretagNamn: anv.CompanyName,
							licenseId: anv.LicenseId,
							foretagId: anv.CompanyId,
							personId: anv.PersonId,
							forandringsskydd: licensForetagPersonForandringsskydd,		// LicenseForetagPerson...
						},
				})
			);

			return mc;
		},

		//======================================================================================================================================

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'andraAnvandare':
					{
						// eventData:
						// anv,
						// anvandartyp,
						// licensForetagPersonForandringsskydd

						this.onAndraAnvandare(eventData.anv, eventData.anvandartyp, eventData.licensForetagPersonForandringsskydd);
						break;
					}

				case 'skickaInbjudanPaNytt':
					{
						// eventData:
						// anvandartyp: anvandartyp,
						// licenseId: anv.LicenseId,
						// atkomstTillforetagId: anv.CompanyId,
						// atkomstTillforetagNamn: anv.CompanyName,
						// inbjudenPersonId: anv.PersonId,
						// inbjudenPersonEpost: anv.Email,
						// inbjudenPersonNamn: anv.Name,
						// forandringsskydd: licensForetagPersonForandringsskydd,		// LicenseForetagPerson...

						//console.log('Skicka inbjudan på nytt', eventData);

						this.visaMeddelande(
							'Vill du skicka inbjudan på nytt till <b>'
							+ (eventData.inbjudenPersonNamn ?
								eventData.inbjudenPersonNamn :
								eventData.inbjudenPersonEpost)
							+ '</b>, att få åtkomst till '
							+ (eventData.atkomstTillforetagId === '00000000-0000-0000-0000-000000000000' ?
								'alla företag' :
								`<b>${eventData.atkomstTillforetagNamn}</b>`
							)
							+ '?',
							{
								dialogId: 'skickaInbjudanPaNyttBekraftelse',
								ikon: 'fragemeddelande',
								ikonCssModifierClass: '-info',
								knappar: [
										new euiDialogClasses.knappAvbryt(),
										new euiDialogClasses.knappEvent('Skicka inbjudan', 'skickaInbjudanPaNyttBekraftad', { eventData: eventData }),
									],
								//breddMedEnhet: '36rem',	// Default = '36rem'.
							}
						);

						break;
					}

				//case 'aterstallLosen':
				//	{
				//		console.log('Återställ lösen');
				//		break;
				//	}

				case 'taBortAtkomst':
					{
						// eventData:
						// personName: anv.Name,
						// personEmail: anv.Email,
						// foretagNamn: anv.CompanyName,
						// licenseId: anv.LicenseId,
						// foretagId: anv.CompanyId,
						// personId: anv.PersonId,
						// forandringsskydd: licensForetagPersonForandringsskydd,		// LicenseForetagPerson...

						//console.log('Ta bort åtkomsten', eventData);

						this.visaMeddelande(
							'Är du säker på att du vill ta bort åtkomsten till '
							+ (eventData.foretagId === '00000000-0000-0000-0000-000000000000' ?
								'alla företag' :
								`<b>${eventData.foretagNamn}</b>`
							)
							+ ' från <b>'
							+ (eventData.personName ?
								eventData.personName :
								eventData.personEmail)
							+ '</b>?',
							{
								dialogId: 'taBortAtkomstBekraftelse',
								ikon: 'fragemeddelande',
								ikonCssModifierClass: '-info',
								knappar: [
										new euiDialogClasses.knappAvbryt(),
										new euiDialogClasses.knappEvent('Ta bort åtkomsten', 'taBortAtkomstBekraftad', { eventData: eventData }),
									],
								//breddMedEnhet: '36rem',	// Default = '36rem'.
							}
						);

						break;
					}
			}
		},

		onBjudInNyAnvandare() {
			//window.location.href = '/invite/invite';

			// Initiera med "nollade" ursprungsvärden:
			this.inbjudanFormModel = Object.assign({}, this.inbjudanFormModelDefault);
			this.inbjudanFormModelBehorigheterLicens = undefined;
			this.inbjudanFormModelBehorigheterForetag = undefined;

			this.inbjudanDialogConfig.visas = true;
		},

		onAndraAnvandare(anv, anvandartyp, licensForetagPersonForandringsskydd) {

			// Sätt dialogens form model = den aktuella användarens värden:
			this.anvandareFormModel = AnvandareFormModel.castFrom({
				LicenseId: anv.LicenseId,
				ForetagId: anv.CompanyId,
				PersonId: anv.PersonId,
				Anvandartyp: anvandartyp,
				Namn: anv.Name,
				Epost: anv.Email,
				Telefon: anv.PhoneNumber,
				LockedDown: anv.LockedDown,
				PowerUser: anv.PowerUser,
				// Utgått enl spec: SuperUser: anv.SuperUser,
				Administrator: anv.LicenseAdministrator,
				LicenseForetagPersonForandringsskydd: licensForetagPersonForandringsskydd,
			});
			// Denna sätts separat, utanför FormModel ovan, för den ska inte skickas vid submit:
			this.anvandareFormForetagNamn = anv.CompanyName;

			this.anvandareDialogConfig.visas = true;
		},

		onKnappTrycktIInbjudanDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'skickaInbjudan':
					{
						//console.log('Skicka inbjudan', eventId, eventData);

						// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/installningar/skicka-inbjudan', {
							formData: objectToFormData(this.inbjudanFormModel),
							doljSpinnerOnSuccess: true,
							onSuccessFunction: (resultat) => {

								// Obs! Även vid OK-respons så innehåller Resultat ett meddelande att visa!
								// Visa lyckatmeddelandet:
								this.visaResultatmeddelande(resultat, {
										dialogId: 'ibjudanSkickad',
										breddMedEnhet: '40rem',	// Default = '36rem'.
									}
								);

								// Först nu ska dialogen stängas!
								this.inbjudanDialogConfig.visas = false;

								// Detta sker i eventhandler då meddelandet ovan stängs:
								// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								//window.location.reload(true);
							},
						});

						break;
					}
			}
		},

		onKnappTrycktIAnvandareDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'sparaAnvandare':
					{
						//console.log('Spara användaren', eventId, eventData);

						// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/installningar/anvandare-update', {
							formData: objectToFormData(this.anvandareFormModel),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Först nu ska dialogen stängas!
								this.anvandareDialogConfig.visas = false;

								// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								window.location.reload(true);
							},
						});

						break;
					}
			}
		},

		onKnappTrycktIMeddelandedialog({ eventId, eventData })
		{
			switch (eventId) {
				case 'skickaInbjudanPaNyttBekraftad':
					{
						// eventData:
						// anvandartyp: anvandartyp,
						// licenseId: anv.LicenseId,
						// atkomstTillforetagId: anv.CompanyId,
						// atkomstTillforetagNamn: anv.CompanyName,
						// inbjudenPersonId: anv.PersonId,
						// inbjudenPersonEpost: anv.Email,
						// inbjudenPersonNamn: anv.Name,
						// forandringsskydd: forandringsskydd,

						//console.log('Skicka inbjudan på nytt, EFTER bekräftelsen', eventData);

						this.AjaxpostaOchHanteraResultat('/installningar/anvandare-skicka-ibjudan-pa-nytt', {
							formData: objectToFormData({
									anvandartyp: eventData.anvandartyp,
									licenseId: eventData.licenseId,
									atkomstTillforetagId: eventData.atkomstTillforetagId,
									atkomstTillforetagNamn: eventData.atkomstTillforetagNamn,
									inbjudenPersonId: eventData.inbjudenPersonId,
									inbjudenPersonEpost: eventData.inbjudenPersonEpost,
									inbjudenPersonNamn: eventData.inbjudenPersonNamn,
									forandringsskydd: eventData.forandringsskydd,
								}),
							doljSpinnerOnSuccess: true,
							onSuccessFunction: (resultat) => {

								// Obs! Även vid OK-respons så innehåller Resultat ett meddelande att visa!
								// Visa lyckatmeddelandet:
								this.visaResultatmeddelande(resultat, {
										dialogId: 'ibjudanSkickadPaNytt',
										breddMedEnhet: '40rem',	// Default = '36rem'.
									}
								);

								//// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								//window.location.reload(true);
							},
						});

						break;
					}

				case 'taBortAtkomstBekraftad':
					{
						// eventData:
						//personName: anv.Name,
						//personEmail: anv.Email,
						//foretagNamn: anv.CompanyName,
						//licenseId: anv.LicenseId,
						//foretagId: anv.CompanyId,
						//personId: anv.PersonId,
						//forandringsskydd: forandringsskydd,

						//console.log('Ta bort åtkomsten, EFTER bekräftelsen', eventData);

						this.AjaxpostaOchHanteraResultat('/installningar/anvandare-atkomst-delete', {
							formData: objectToFormData({
									licenseId: eventData.licenseId,
									foretagId: eventData.foretagId,
									personId: eventData.personId,

									forandringsskydd: eventData.forandringsskydd,
								}),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								window.location.reload(true);
							},
						});

						break;
					}
			}
		},

		onDialogEllerMeddelandedialogStangs(dialogId)
		{
			switch (dialogId)
			{
				case 'bjudInAnvandare':
					{
						// "Nollar" av sanitära skäl alltid form model efteråt (abruten *eller* ok:ad dialog):
						// Kan *inte* göras här, för värdena anv i efterföljande meddelandedialog med id 'inbjudanSkickad', se nedan.
						break;
					}

				case 'andraAnvandare':
					{
						// "Nollar" av sanitära skäl alltid form model efteråt (abruten *eller* ok:ad dialog):
						this.anvandareFormModel = undefined;
						this.anvandareFormForetagNamn = undefined;

						break;
					}

				case 'ibjudanSkickad':
					{
						// "Nollar" av sanitära skäl alltid form model efteråt (abruten *eller* ok:ad dialog):
						this.inbjudanFormModel = undefined;
						this.inbjudanFormModelBehorigheterLicens = undefined;
						this.inbjudanFormModelBehorigheterForetag = undefined;

						// Hm.. denna hinner antagligen inte träda in, eftersom omrenderingar av sidan antagligen stoppas direkt när navigering initieras:
						this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = true;

						// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
						window.location.reload(true);
						break;
					}
			}
		},

		//onAterstall() {

		//	// Återställ till undansparade värden:
		//	this.formModel = Object.assign({}, this.formModelUndansparad);
		//},
	},


	//== Lifecycle hooks  ================================================================================================================

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		this.$_anvandartypLicens = 'Licens';
		this.$_anvandartypForetag = 'Foretag';

		// Sätt innehåll i dialog/radiogrupp/select för inbjudnings-formuläret:
		// Dessa delar av –"– sätts här för de behöver inte/ska inte vara reaktiva:

		this.$_anvandartypRadiogruppConfig = new euiFormClasses.radiogruppConfig([
				new euiFormClasses.radioknapp('Alla', this.$_anvandartypLicens),		// , { disabled: true }),
				new euiFormClasses.radioknapp('Företaget valt nedan', this.$_anvandartypForetag),
			]
		);

		this.$_foretagSelectConfig = new euiFormClasses.selectConfig();

		for (const f of this.companies)
		{
			this.$_foretagSelectConfig.alternativ.push(new euiFormClasses.selectAlternativ(f.Name, f.Id));
		}
	},

	mounted()
	{
		// Programmatisk bind:
		this.$on('knapp-tryckt-i-meddelandedialog', this.onKnappTrycktIMeddelandedialog);
		this.$on('meddelandedialog-stangs', this.onDialogEllerMeddelandedialogStangs);
		this.$on('dialogen-stangs', this.onDialogEllerMeddelandedialogStangs);
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

// Görs nu i ssoAllaSidorMixin:
//console.time('#TIMING: initieraTooltips');	// Todo: TEMP!!!
//ssoTooltips.initiera(document.body);
//console.timeEnd('#TIMING: initieraTooltips');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;


